var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"news"},[_c('div',{staticClass:"newsXq"},[_c('p',{staticClass:"title"},[_vm._v(_vm._s(_vm.htmlText.title))]),_vm._v(" "),_c('p',{staticClass:"desc"},[_vm._v(_vm._s(_vm.htmlText.englishTitle))]),_vm._v(" "),_c('div',{staticClass:"contentHtml",domProps:{"innerHTML":_vm._s(_vm.htmlText.text)}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1ae719a1","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/department/departmentXq.vue
// module id = null
// module chunks = 